// import * as facultyDiapoStyles from '../../styles/internal-page/faculty-diapo.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import DiapoPres from '../shared/carrousels/DiapoPres';
import FacultyContent from './FacultyContent';
import CkEditor from '../shared/ckeditor/CkEditor';

import { useTranslation } from 'react-i18next';

const FacultyDiapo = ({content}) => {
  const {t} = useTranslation();
  const tmpContent = {...content};


  let testimonies = [];
  if (content?.contacts && content?.contacts.length > 0) {
    testimonies = content?.contacts
      .filter ( (e) => !!e)
      .map((elem)=> {
        return ({
          ...elem,
          children:
            <FacultyContent elem={elem}/>
        });
      });
  }
  tmpContent.testimonies = testimonies;

  /*
  tmpContent.testimonies = content.contacts.map((elem) => {
    return ({
      ...elem,
      children:
        <FacultyContent elem={elem}/>
    })
  })
  */

  return (
    <div>
      <h2>
        {t('exed.product.faculty.title')}
      </h2>
      {content?.introduction && <CkEditor html={content.introduction}></CkEditor>}
      <DiapoPres content={tmpContent}/>
    </div>
  );
};

FacultyDiapo.propTypes = {
  content: PropTypes.shape({
    contacts: PropTypes.arrayOf(PropTypes.shape({
      last_name: PropTypes.string,
      first_name: PropTypes.string,
      jobs: PropTypes.string,
      biography: PropTypes.string,
      picture: PropTypes.object,
    })).isRequired,
    introduction: PropTypes.string,
  }).isRequired,
};

export default FacultyDiapo;
